import { toast } from 'sonner'
import { REVIEW_IN_PROGRESS } from '@/features/moderation/lib/reviewInProgress'
import type { TranslationStatus } from './useTranslation'
import { messagesNow } from '@/i18n'
import { messages } from './messages'

const codeOf = (data: Record<string, unknown> | undefined): unknown =>
  (data?.detail as { code?: unknown } | undefined)?.code

/** Разбирает отказ старта перевода: показывает тост и возвращает статус, в который встать. */
export const reportStartFailure = (err: unknown, retryForced: () => void): TranslationStatus => {
  const status = (err as { status?: number })?.status
  const data = (err as { data?: Record<string, unknown> })?.data
  const m = messagesNow(messages)

  // Статья на проверке: перевод записал бы черновик под заявкой. Тост с текстом по имени
  // ручки даёт `errorToastMiddleware` (он же перечитывает модерацию — форма замерзает).
  // «Перевести заново» не предлагаем: force упрётся в ту же заморозку.
  if (status === 409 && codeOf(data) === REVIEW_IN_PROGRESS) return 'idle'

  if (status === 409) {
    toast.info(m.translationFresh, {
      action: { label: m.translateAgain, onClick: retryForced },
    })
    return 'already_fresh'
  }

  if (status === 429) {
    const detail = data?.detail as { retry_after?: number } | undefined
    const minutes = Math.ceil((detail?.retry_after ?? 60) / 60)
    toast.error(m.translateRateLimit(minutes))
    return 'idle'
  }

  toast.error(m.translateStartFailed)
  return 'idle'
}
